import * as React from "react";

const SvgComponent = (props) => (
  <svg
    width={46}
    height={45}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle opacity={0.2} cx={23} cy={22.5} r={22.5} fill="#C4C4C4" />
    <path
      d="M32.012 27.116v-1.758h.66c.71 0 1.319-.61 1.319-1.32v-3.077c0-.71-.609-1.319-1.32-1.319h-.659v-1.758c0-.71-.608-1.32-1.319-1.32H13.108c-.71 0-1.1.659-1.1 1.369v9.134c0 .71.39 1.368 1.1 1.368h17.585c.71 0 1.32-.609 1.32-1.319Zm-18.245 0c-.064 0-.22-.155-.22-.22v-8.573c0-.064.156-.22.22-.22h16.487c.064 0 .22.156.22.22v8.573c0 .065-.155.22-.22.22H13.767Z"
      fill="#222"
    />
    <path
      d="M21.322 18.524v3.686l-6.08-1.725 8.06 5.992V22.79l6.078 1.725-8.058-5.992Z"
      fill="#222"
    />
  </svg>
);

export default SvgComponent;
